import { useState } from 'react'

const useChatOverlays = ({
  dispatch,
  setRoutineOpen,
  goToPricing,
}) => {
  const [diagOpen, setDiagOpen] = useState(false)

  const [upgradeAlert, setUpgradeAlert] = useState({
    visible: false,
    feature: null,
    minPlan: null,
  })

  const openDiagnostics = () => {
    setDiagOpen(true)
  }

  const closeDiagnostics = () => {
    setDiagOpen(false)
    dispatch(setRoutineOpen(false))
  }

  const openUpgradeAlert = ({
    feature = null,
    minPlan = null,
  } = {}) => {
    setUpgradeAlert({
      visible: true,
      feature,
      minPlan,
    })
  }

  const closeUpgradeAlert = () => {
    setUpgradeAlert({
      visible: false,
      feature: null,
      minPlan: null,
    })
  }

  const viewPlans = () => {
    closeUpgradeAlert()
    goToPricing?.()
  }

  return {
    diagOpen,
    upgradeAlert,
    openDiagnostics,
    closeDiagnostics,
    openUpgradeAlert,
    closeUpgradeAlert,
    viewPlans,
  }
}

export default useChatOverlays